import { createActions, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';

export const types = {
  TOGGLE_DOWNLOAD_DIALOG: 'TOGGLE_DOWNLOAD_DIALOG',
  OPEN_TIME_BASED_BLOCK_DIALOG: 'OPEN_TIME_BASED_BLOCK_DIALOG',
};

export const { toggleDownloadDialog, openTimeBasedBlockDialog } = createActions(
  types.TOGGLE_DOWNLOAD_DIALOG,
  types.OPEN_TIME_BASED_BLOCK_DIALOG
);

const INIT_STATE = {
  isOpen: false,
  isTimeBasedBlock: false,
};

const reducer = handleActions(
  {
    [types.TOGGLE_DOWNLOAD_DIALOG]: (state) => ({
      ...state,
      isOpen: !state.isOpen,
      isTimeBasedBlock: false,
    }),
    [types.OPEN_TIME_BASED_BLOCK_DIALOG]: (state) => ({
      ...state,
      isOpen: true,
      isTimeBasedBlock: true,
    }),
  },
  INIT_STATE
);

export default reducer;
export const getDownloadDialog = (state) => state.downloadDialog;
export const getDownloadDialogStatus = createSelector(
  getDownloadDialog,
  (downloadDialog) => downloadDialog.isOpen
);
export const getIsTimeBasedBlock = createSelector(
  getDownloadDialog,
  (downloadDialog) => downloadDialog.isTimeBasedBlock
);



// WEBPACK FOOTER //
// ./src/services/redux/downloadDialog.js